import { DiFirebase, DiReact, DiZend } from "react-icons/di";

function Technologies() {
  return (
    <section id="technologies">
      <div class="container mx-auto mb-5">
        <div class="flex flex-col max-w-md md:w-1/2 mb-10 space-y-5 md:ml-10 xlg:ml-36 justify-around">
          <h1 class="text-4xl font-bold text-center md:text-5xl md:max-w-md md:ml-11 lg:ml-20">
            Technologies
          </h1>

          <p class="text-center text-darkGrayishBlue md:max-w-sm md:text-left md:ml-20 lg:ml-32">
            I have worked with a range of technologies in the web development
            world. From backend to design.
          </p>
        </div>

        <div class="container mx-auto space-y-6 mb-4 md:max-w-md md:items-center ">
          <div class="flex space-x-3 md:flex-row  md:items-baseline md:max-w-md justify-evenly ml-8 ">
            <div>
              <DiReact size="2rem" />
              <h1 class="font-semibold">Front-End</h1>
              <p class="text-darkGrayishBlue">
                Experience with React.js and Laravel.
              </p>
            </div>
            <div>
              <DiFirebase size="2rem" />
              <h1 class="font-semibold">Back-End</h1>
              <p class="text-darkGrayishBlue">
                Experience with Node and Databases.
              </p>
            </div>
            <div>
              <DiZend size="2rem" />
              <h1 class="font-semibold">UI/UX</h1>
              <p class="text-darkGrayishBlue">
                Experience with tools like Figma and mockitt.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Technologies;
